import React, { Component } from 'react'
import ReactMarkdown from "react-markdown"
import {Link} from 'gatsby'


class EventGrid extends Component {
  constructor(props) {
    super(props)



    this.layoutContents = React.createRef()
    this.transitionCover = React.createRef()
  }

  render() {

    return (
      <li class="slice__item list__item row__item row__item--span-1">

                                              <div class="item itemEnlarge item--forecast">
                                                  <div class="item__container" style={{backgroundColor:this.props.data.TileBackgroundColor ,borderColor:this.props.data.TileBordercolor}} >
                                                      <div class="item__media">

                                                      </div>
                                                      <div class="item__content service">
                                                          <div class="item__header">
                                                              <h3 class="item__title" style={{color:this.props.data.TileTextColor}}>

                                                                        {this.props.data.title}

                                                              </h3>
                                                          </div>
                                                          <div class="item__teaser">
                                                              {this.props.data.title}
                                                          </div>
                                                      </div>
                                                      <Link class="block-link-overlay"
                                                        to={`/services/${this.props.data.slug}`}
                                                      />
                                                  </div>
                                              </div>

                                          </li>



    )


}
}

export default EventGrid;
